module.exports = __webpack_public_path__ + "03675015e38718d73ae81584be6ff64e.pdf";